(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["aa-ugc-videos"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function playSafe(video) {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    // Arrows + progress bar so shoppers can see there are more videos
    // to the side. Both stay hidden while every video already fits.
    function initScrollNav(root) {
      var track = root.querySelector('[data-ugc-track]');
      if (!track) return;
      var prev = root.querySelector('[data-ugc-scroll-prev]');
      var next = root.querySelector('[data-ugc-scroll-next]');
      var thumb = root.querySelector('[data-ugc-progress]');
      var ticking = false;

      function update() {
        ticking = false;
        var max = track.scrollWidth - track.clientWidth;
        var overflow = max > 2;
        root.classList.toggle('has-overflow', overflow);
        if (!overflow) return;

        var pos = Math.min(Math.max(track.scrollLeft, 0), max);
        if (prev) prev.disabled = pos <= 2;
        if (next) next.disabled = pos >= max - 2;

        if (thumb) {
          var visible = track.clientWidth / track.scrollWidth;
          thumb.style.width = visible * 100 + '%';
          thumb.style.transform = 'translateX(' + (pos / max) * ((1 - visible) / visible) * 100 + '%)';
        }
      }

      function requestUpdate() {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }

      function scrollByPage(dir) {
        var slide = track.firstElementChild;
        var step = slide ? slide.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : 100;
        var perPage = Math.max(1, Math.floor(track.clientWidth / step));
        track.scrollBy({ left: dir * step * perPage, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { scrollByPage(-1); });
      if (next) next.addEventListener('click', function () { scrollByPage(1); });
      track.addEventListener('scroll', requestUpdate, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(requestUpdate).observe(track);
      } else {
        window.addEventListener('resize', requestUpdate);
      }
      update();
    }

    function initUgc(root) {
      if (!root || root.dataset.ugcInit === 'true') return;
      root.dataset.ugcInit = 'true';

      initScrollNav(root);

      var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-ugc-tile]'));
      if (!tiles.length) return;

      var previews = tiles.map(function (tile) {
        return tile.querySelector('video');
      });
      var autoplay = root.dataset.ugcAutoplay === 'true' && !reduceMotion;
      var inView = false;
      var dialogOpen = false;

      function setPreviews(play) {
        previews.forEach(function (v) {
          if (!v) return;
          if (play) {
            playSafe(v);
          } else {
            v.pause();
          }
        });
      }

      if (autoplay && 'IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entries) {
            inView = entries[0].isIntersecting;
            if (!dialogOpen) setPreviews(inView);
          },
          { rootMargin: '100px' }
        ).observe(root);
      } else if (!autoplay) {
        // Without autoplay, preview on hover (desktop only).
        tiles.forEach(function (tile, i) {
          var v = previews[i];
          if (!v) return;
          tile.addEventListener('mouseenter', function () {
            playSafe(v);
          });
          tile.addEventListener('mouseleave', function () {
            v.pause();
          });
        });
      }

      var dialog = root.querySelector('[data-ugc-dialog]');
      if (root.dataset.ugcLightbox !== 'true' || !dialog || typeof dialog.showModal !== 'function') return;

      // Move the dialog to <body> so a transformed/overflow-hidden ancestor
      // can't clip it; keep a reference for cleanup on section reload.
      document.body.appendChild(dialog);
      root._ugcDialog = dialog;

      var player = dialog.querySelector('[data-ugc-dialog-video]');
      var caption = dialog.querySelector('[data-ugc-dialog-caption]');
      var prevBtn = dialog.querySelector('[data-ugc-prev]');
      var nextBtn = dialog.querySelector('[data-ugc-next]');
      var current = 0;

      function show(index) {
        current = (index + tiles.length) % tiles.length;
        var tile = tiles[current];
        var preview = previews[current];

        player.pause();
        player.innerHTML = '';
        if (preview) {
          preview.querySelectorAll('source').forEach(function (s) {
            player.appendChild(s.cloneNode());
          });
          if (preview.poster) player.poster = preview.poster;
        }
        player.muted = false;
        player.load();
        playSafe(player);

        var text = tile.dataset.ugcCaption || '';
        caption.textContent = text;
        caption.hidden = !text;

        var single = tiles.length < 2;
        prevBtn.hidden = single;
        nextBtn.hidden = single;
      }

      function open(index) {
        dialogOpen = true;
        setPreviews(false);
        dialog.showModal();
        show(index);
      }

      tiles.forEach(function (tile, i) {
        tile.addEventListener('click', function () {
          open(i);
        });
      });

      prevBtn.addEventListener('click', function () {
        show(current - 1);
      });
      nextBtn.addEventListener('click', function () {
        show(current + 1);
      });
      dialog.querySelector('[data-ugc-close]').addEventListener('click', function () {
        dialog.close();
      });

      // Click on the dark area (not the video or buttons) closes.
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.classList.contains('aa-ugc__dialog-inner')) dialog.close();
      });

      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
      });

      dialog.addEventListener('close', function () {
        dialogOpen = false;
        player.pause();
        player.removeAttribute('poster');
        player.innerHTML = '';
        player.load();
        tiles[current].focus({ preventScroll: true });
        if (autoplay && inView) setPreviews(true);
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-ugc-root]').forEach(initUgc);
    }

    initAll(document);

    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('[data-ugc-root]').forEach(function (root) {
        if (root._ugcDialog) root._ugcDialog.remove();
      });
    });

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
